import { useMemo } from 'react';
import {
  selectBatchDetails,
  selectOttVideoDetails,
  selectPlayerParams,
  selectScheduleDetails,
  useSelector,
} from 'src/lib/redux';

import { BatchDetailModel } from '../batches/useBatchDetails';
import { ScheduleDetails } from './useScheduleDetails';

export const useMetaData = () => {
  const { cameFrom } = useSelector(selectPlayerParams);
  const rawBatchDetails = useSelector(selectBatchDetails);
  const rawScheduleDetails = useSelector(selectScheduleDetails);
  const rawOttVideoDetails = useSelector(selectOttVideoDetails);

  const batchDetails = useMemo(() => new BatchDetailModel(rawBatchDetails), [rawBatchDetails]);

  const scheduleDetails = useMemo(
    () => new ScheduleDetails(rawScheduleDetails, cameFrom),
    [rawScheduleDetails, cameFrom],
  );

  const ottVideoDetails = useMemo(() => rawOttVideoDetails, [rawOttVideoDetails]);

  return { scheduleDetails, batchDetails, ottVideoDetails };
};

export default useMetaData;
